import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Cursos', path: '/cursos' },
    { name: 'Test', path: '/test' },
    { name: 'Nosotros', path: '/nosotros' },
    { name: 'Contacto', path: '/contacto' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            {isHomePage ? (
              <h1 className="flex items-center gap-3">
                <img
                  src="https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/4b755a8beaf3238abeae556b320a2b38.png"
                  alt="AULA K9 Logo"
                  className="w-24 h-24 object-contain"
                />
                <div className="flex flex-col">
                  <span className={`text-2xl font-bold ${isScrolled || !isHomePage ? 'text-gray-800' : 'text-white'}`}>
                    Aula K<span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold', fontStyle: 'italic' }}>9</span>
                  </span>
                  <span className={`text-sm font-bold italic ${isScrolled || !isHomePage ? 'text-gray-800' : 'text-white'}`} style={{ fontFamily: 'Georgia, serif' }}>
                    Don Bandi 'El Taller de Pensar'
                  </span>
                </div>
              </h1>
            ) : (
              <>
                <img
                  src="https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/4b755a8beaf3238abeae556b320a2b38.png"
                  alt="AULA K9 Logo"
                  className="w-24 h-24 object-contain"
                />
                <div className="flex flex-col">
                  <span className={`text-2xl font-bold ${isScrolled || !isHomePage ? 'text-gray-800' : 'text-white'}`}>
                    Aula K<span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold', fontStyle: 'italic' }}>9</span>
                  </span>
                  <span className={`text-sm font-bold italic ${isScrolled || !isHomePage ? 'text-gray-800' : 'text-white'}`} style={{ fontFamily: 'Georgia, serif' }}>
                    Don Bandi 'El Taller de Pensar'
                  </span>
                </div>
              </>
            )}
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className={`font-semibold transition-colors cursor-pointer ${
                  isScrolled || !isHomePage
                    ? 'text-gray-700 hover:text-accent-500'
                    : 'text-white hover:text-accent-200'
                }`}
              >
                {link.name}
              </a>
            ))}
            <a
              href="/login"
              className="rounded-full bg-accent-500 px-6 py-2.5 text-sm font-semibold text-white shadow-lg hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Acceso Alumnos
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled || !isHomePage ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-semibold cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a
              href="/login"
              className="block mx-4 mt-2 text-center rounded-full bg-accent-500 px-6 py-2.5 text-sm font-semibold text-white shadow-lg hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Acceso Alumnos
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
